import type { HeaderPickerKind } from '@xsscool/shared';
import { CSPPicker } from './CSPPicker';
import { XFrameOptionsPicker } from './XFrameOptionsPicker';
import { SetCookiePicker } from './SetCookiePicker';
import { ReferrerPolicyPicker } from './ReferrerPolicyPicker';
import { ContentDispositionPicker } from './ContentDispositionPicker';
import { CorsOriginPicker } from './CorsOriginPicker';
import type { PickerProps } from './types';

export function HeaderValuePicker({
  kind,
  value,
  onChange,
}: { kind: HeaderPickerKind } & PickerProps) {
  switch (kind) {
    case 'csp':
      return <CSPPicker value={value} onChange={onChange} />;
    case 'xfo':
      return <XFrameOptionsPicker value={value} onChange={onChange} />;
    case 'set-cookie':
      return <SetCookiePicker value={value} onChange={onChange} />;
    case 'referrer-policy':
      return <ReferrerPolicyPicker value={value} onChange={onChange} />;
    case 'content-disposition':
      return <ContentDispositionPicker value={value} onChange={onChange} />;
    case 'cors-origin':
      return <CorsOriginPicker value={value} onChange={onChange} />;
  }
}

export function pickerKindForHeaderName(
  name: string,
): HeaderPickerKind | undefined {
  const lower = name.trim().toLowerCase();
  if (lower === 'content-security-policy') return 'csp';
  if (lower === 'x-frame-options') return 'xfo';
  if (lower === 'set-cookie') return 'set-cookie';
  if (lower === 'referrer-policy') return 'referrer-policy';
  if (lower === 'content-disposition') return 'content-disposition';
  if (lower === 'access-control-allow-origin') return 'cors-origin';
  return undefined;
}
